module.exports = __webpack_public_path__ + "img/banner_R3.4338bd05.png";